import { NoLogo } from 'assets/images'
import { IRestaurantDetailData } from 'interfaces/restaurant'
import { JSX } from 'react'

interface TabStatusCardProps {
  restaurantData: IRestaurantDetailData
  message: string
  subMessage?: string | JSX.Element
  className?: string
}

const TabStatusCard = ({
  restaurantData,
  message,
  subMessage,
  className = '',
}: TabStatusCardProps) => {
  return (
    <div className={`card empty-tab ${className}`}>
      {restaurantData?.businessLogoPath ? (
        <img src={restaurantData?.businessLogoPath} alt="FasTab" />
      ) : (
        <img src={NoLogo} alt="FasTab" />
      )}
      <p>{message}</p>
      {subMessage && <span>{subMessage}</span>}
    </div>
  )
}

export default TabStatusCard
